var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMac(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0929 17.4897C21.5409 18.7119 21.2769 19.2583 20.5679 20.3383C19.5775 21.8466 18.179 23.7288 16.4501 23.7417C14.9123 23.7546 14.5153 22.7383 12.4283 22.7549C10.3412 22.7651 9.90641 23.7602 8.36672 23.7445C6.6378 23.7288 5.3141 22.0331 4.32272 20.5276C1.55072 16.3045 1.2581 11.3549 2.97133 8.7214C4.18333 6.85401 6.10149 5.7574 7.90241 5.7574C9.73656 5.7574 10.8895 6.7654 12.4061 6.7654C13.8775 6.7654 14.7738 5.75463 16.895 5.75463C18.4993 5.75463 20.1959 6.62878 21.4079 8.13709C17.4424 10.31 18.0867 15.974 22.0929 17.4897ZM15.2852 4.06909C16.0569 3.07863 16.6421 1.68109 16.4298 0.255859C15.1707 0.341706 13.6984 1.14571 12.8381 2.18694C12.059 3.13494 11.4129 4.54355 11.6649 5.90601C13.0384 5.95032 14.4599 5.13155 15.2852 4.06909Z",
    fill: "#4A47E5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMac);
export default __webpack_public_path__ + "static/media/mac.40a186e8.svg";
export { ForwardRef as ReactComponent };